import axios from "axios";

class InvoiceService {
    getInvoice(payload) {
        return axios.get(`invoice?${payload}`);
    }
    getPaymentsExport() {
        return axios.get(`invoice?pageSize=9999`);
    }
}

export default new InvoiceService();